import React, { useEffect, useState } from "react";
import { MinimumConfiguration } from "./components/minimumConfiguration";
// import { EnvironmentSummary } from "./components/environmentSummary";
import { useSearchParams } from "react-router-dom";
import MinimumConfigurationAINew from "./components/minimumConfiguration/MinimumConfigurationAINew";

const ViewEnvironment = () => {
  const [searchParams] = useSearchParams();
  const [showNetwork, setShowNetwork] = useState("AI");

  const mode = searchParams.get("mode"); // "AI" | "MANUAL"

  useEffect(() => {
    if (mode === "AI") {
      setShowNetwork("AI");
    } else if (mode === "Manual" || !mode) {
      setShowNetwork("Manual");
    }
  }, [mode]);

  // this state will mange the conditional move from one to other page
  const [activeStep, setActiveStep] = useState(0);
  // move to the next page
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  // move back to the page
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  return (
    <React.Fragment>
      {/* Render the appropriate component based on the active step /}
      {/ {activeStep === 0 ? (
        <EnvironmentSummary handleNext={handleNext} />
      ) : activeStep === 1 ? (
        <MinimumConfiguration handleBack={handleBack} />
      ) : null} */}
      {showNetwork === "Manual" && <MinimumConfiguration />}
      {showNetwork === "AI" && <MinimumConfigurationAINew />}
    </React.Fragment>
  );
};

export default ViewEnvironment;
